import { useEffect, useRef, useState } from "react";

export function useWorkingSetlist() {
  const [selectedSongs, setSelectedSongs] = useState([]);
  const [isSetlistCollapsed, setIsSetlistCollapsed] = useState(true);

  const prevSelectedSongsRef = useRef([]);
  const newlyAddedSongIds = new Set(
    selectedSongs.filter((id) => !prevSelectedSongsRef.current.includes(id))
  );
  useEffect(() => {
    prevSelectedSongsRef.current = selectedSongs;
  }, [selectedSongs]);

  const handleSelectSong = (id, isSelected) => {
    if (isSelected) {
      setSelectedSongs((prev) => (prev.includes(id) ? prev : [...prev, id]));
      setIsSetlistCollapsed(false);
      return;
    }
    setSelectedSongs((prev) => prev.filter((songId) => songId !== id));
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;
    const newOrder = [...selectedSongs];
    const [moved] = newOrder.splice(result.source.index, 1);
    newOrder.splice(result.destination.index, 0, moved);
    setSelectedSongs(newOrder);
  };

  const handleMoveSong = (index, direction) => {
    if (direction === "up" && index === 0) return;
    if (direction === "down" && index === selectedSongs.length - 1) return;
    const newOrder = [...selectedSongs];
    const swapIndex = direction === "up" ? index - 1 : index + 1;
    [newOrder[index], newOrder[swapIndex]] = [newOrder[swapIndex], newOrder[index]];
    setSelectedSongs(newOrder);
  };

  const clearSetlist = () => setSelectedSongs([]);

  const toggleCollapsed = () => setIsSetlistCollapsed((c) => !c);

  return {
    selectedSongs,
    setSelectedSongs,
    isSetlistCollapsed,
    toggleCollapsed,
    handleSelectSong,
    onDragEnd,
    handleMoveSong,
    clearSetlist,
    newlyAddedSongIds,
  };
}
